import React, {useCallback, useEffect, useMemo} from "react";
import {
  CardActions,
  CardBody,
  CardFooter,
  CardHeader,
  CardId,
  CardTitle,
  CardFooterItem,
  CardContainer,
} from "./ConversationItemCard.styled";
import dayjs from "dayjs";
import {createSearchParams, useNavigate} from "react-router-dom";
import {ConversationType, ConversationStatus, InboxButton, OptionsButton} from "./components";
import {observer} from "mobx-react";
import {useUserCheckPermissions} from "../../../../../hooks/useUserCheckPermissions";
import { PermissionCodes } from "../../../../../utils/enums";

export const ConversationItemCard = observer(({ conversation, users, onOpenInbox }) => {
  const navigate = useNavigate();
  const {checkPermission} = useUserCheckPermissions();

  const getUser = (owner) => {
    if (owner) {
      const userOwner = users.find((user) => user.id === owner);
      return userOwner ? `${userOwner.first_name} ${userOwner.last_name}` : '-';
    }
    return "-";
  }
  
  const onClickItem = (id, type) => {
    const page = type.toLowerCase() === "trigger" ? "trigger" : "marketing";
    navigate({
      pathname: `/v2/conversations/${page}`,
      search: createSearchParams({
        id: id,
      }).toString(),
    });
  }
  
  const onHandleOpenInbox = useCallback((conversation) => {
    onOpenInbox && onOpenInbox(conversation);
  }, []);
  
  return (
    <CardContainer key={conversation.id}>
      <CardHeader>
        <CardTitle onClick={() => onClickItem(conversation.id, conversation.conversationType)}>{conversation.name}</CardTitle>
        <CardActions>
          <ConversationType type={conversation.conversationType} />
          <ConversationStatus status={conversation.status} />
          {checkPermission(PermissionCodes.CONVERSATIONS_VIEWER, "UPDATE") && (<InboxButton onClick={() => onHandleOpenInbox(conversation)} />)}
          <OptionsButton conversation={conversation} />
        </CardActions>
      </CardHeader>
      <CardBody>{conversation?.metadata?.description}</CardBody>
      <CardFooter>
        <CardId onClick={() => onClickItem(conversation.id, conversation.conversationType)}>#{conversation.conversationNumber}</CardId>
        <CardFooterItem><span>Created by</span>{getUser(conversation.owner)}</CardFooterItem>
        <CardFooterItem><span>Last updated</span>{dayjs(conversation.last_modified || "").format("MM/DD/YYYY")}</CardFooterItem>
      </CardFooter>
    </CardContainer>
  );
});
